var tableColumnTitles = {
    UNIT: "ENERGY_SAVING_UNIT",
    SAVING: "ENERGY_SAVING_TITLE",
    REFERENCE_CONSUMPTION: "WITHOUT_PAUL_CONSUMPTION",
    FOCUS_CONSUMPTION: "WITH_PAUL_CONSUMPTION",
    DATE_TITLE: "DATE_TITLE",
};
// @ts-ignore
export var dataTableColumns = function (tI) { return [
    {
        field: "unit",
        headerName: tI[tableColumnTitles.UNIT],
        flex: 1,
    },
    {
        field: "saving",
        headerName: tI[tableColumnTitles.SAVING],
        flex: 1,
    },
    {
        field: "referenceConsumption",
        headerName: tI[tableColumnTitles.REFERENCE_CONSUMPTION],
        flex: 1,
    },
    {
        field: "focusConsumption",
        headerName: tI[tableColumnTitles.FOCUS_CONSUMPTION],
        flex: 1,
    },
]; };
